// extracted by mini-css-extract-plugin
module.exports = {"container":"bullets_container__veUAD","bullets":"bullets_bullets__3vhi3","bullet":"bullets_bullet__2mo-4","active":"bullets_active__255Ar"};